import { isMinRedeemBypassed, minRedeemUsd } from './rewards-config'

export function isRedeemEnabled(
  availableBalanceUsd: number | undefined,
  redeemFulfillmentAvailable = true,
): boolean {
  if (!redeemFulfillmentAvailable) return false
  if (availableBalanceUsd === undefined) return false
  if (isMinRedeemBypassed) return availableBalanceUsd > 0
  return availableBalanceUsd >= minRedeemUsd
}
